import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import PagamentosService from "../../../services/PagamentosService";
import moment from 'moment';
import { formatarDataISO8601, formatarValorReal } from "../../../utils/formatar";

export default class DetalhesLotePagamentoStore  {

    @observable detalhes;
    @observable loading;

    constructor() {
        this.loading = false;
        this.pagamentoService = new PagamentosService();
    }

    setLista(motsList) {
        this.detalhes.mots = motsList;
    }

    loadDetalhes(loteId) {
        this.loading = true;

        this.pagamentoService.detalhesLote(loteId).then(response => {
            this.detalhes = response.data;
            this.loading = false;
        }).catch(erro => {
            console.log(erro);
            this.loading = false;
        });
    }

    @computed get numeroNotaFiscal() {
        if (this.detalhes && this.detalhes.notasFiscais && this.detalhes.notasFiscais.length > 0) {
            let nota = this.detalhes.notasFiscais[0];
            return nota.numero;
        } else {
            return "";
        }
    }

    @computed get dataEmissaoNotaFiscal() {
        if (this.detalhes && this.detalhes.notasFiscais && this.detalhes.notasFiscais.length > 0) {
            let nota = this.detalhes.notasFiscais[0];
            return formatarDataISO8601(nota.dataEmissao);
        } else {
            return "";
        }
    }

    @computed get dataVencimentoNotaFiscal() {
        if (this.detalhes && this.detalhes.notasFiscais && this.detalhes.notasFiscais.length > 0) {
            let nota = this.detalhes.notasFiscais[0];
            return formatarDataISO8601(nota.dataVencimento);
        } else {
            return "";
        }
    }

    @computed get serieNotaFiscal() {
        if (this.detalhes && this.detalhes.notasFiscais && this.detalhes.notasFiscais.length > 0) {
            let nota = this.detalhes.notasFiscais[0];
            return nota.serie;
        } else {
            return "";
        }
    }

    @computed get lote() {
        if (this.detalhes && this.detalhes.id) {
            return this.detalhes.id;
        } else {
            return "";
        }
    }

    @computed get nomeEmpresaGlobo() {
        if (this.detalhes && this.detalhes.nomeEmpresaGlobo) {
            return this.detalhes.nomeEmpresaGlobo;
        } else {
            return "";
        }
    }

    @computed get valorTotal() {
        if (this.detalhes && this.detalhes.valorTotal) {
            return formatarValorReal(this.detalhes.valorTotal);
        } else {
            return "";
        }
    }

    @computed get dataGeracao() {
        if (this.detalhes && this.detalhes.dataGeracao) {
            return formatarDataISO8601(this.detalhes.dataGeracao);
        } else {
            return "";
        }
    }

    @computed get mots() {
        if (this.detalhes && this.detalhes.mots) {
            return this.detalhes.mots;
        } else {
            return [];
        }
    }
}